import palette from '../palette';

export default {
  styleOverrides: {
    input: {
      '&[type=number]': {
        '-moz-appearance': 'textfield'
      },
      '&[type=number]::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      },
      '&[type=number]::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0
      },
      '&::placeholder': {
        opacity: 1,
        color: palette.text.secondary
      }
    }
  }
};
